export interface Product {
  id: number,
  title: string,
  enterprise_id?: number,

  price: number,
  opt_price?: number,
  big_opt_price?: number,
  wholesale_price?: number,
  percent_markup?: number,
  value: number

  in_bookmarks: boolean,
  color?: string,
  category_id?: number,
  category_title:string,
  type_category_id: number,

  photos: Array<string>,
  bar_code: Array<string>,
  qr_code: Array<string>,
  article?: string,
  measure_short_title:string,
  measure_title:string,
  measure_id:number,

  min_value?: number,
  max_value?: number,
}

export interface Measure {
  id:number,
  parent_id?: number,
  title: string,
  short_title: string
}

export const PRICE_TYPES = {
  opt_price: 1,
  big_opt_price: 2,
  price: 0
};
